import React, { useState} from "react";
import { NavDropdown, Image } from 'react-bootstrap';
import { useAuth } from "../../auth/auth";
import dropdownImage from '../../images/hamburger.png'
import { Link } from 'react-router-dom';
import { useIsAuthenticated } from "@azure/msal-react";

const HamburgerMenuImage = (
    <span>
        <Image src={dropdownImage}
            style={{ width: '23px', paddingBottom: '1px'}}
        />
    </span>
)

export const HamburgerMenu = () => {
    const { getRoles } = useAuth();
    const [showTapForm, setShowTapForm] = useState(false);
    const [showMfaForm, setShowMfaForm] = useState(false);
    const [showMfaBulkForm, setShowMfaBulkForm] = useState(false);
    const [showTouForm, setShowTouForm] = useState(false);
    const [showSignInActivityForm, setShowSignInActivityForm] = useState(false);
    const [showSummerrainUsersForm, setShowSummerrainUsersForm] = useState(false);
    const [showAdLockoutForm, setShowAdLockoutForm] = useState(false);
    const [showSharePointForm, setShowSharepointForm] = useState(false);
    const [showB2CSignInEventsForm, setShowB2CSignInEventsForm] = useState(false);
    const [showActivityLogForm, setShowActivityLogForm] = useState(false);
    const [showAppRegistrationForm, setShowAppRegistrationForm] = useState(false);

    //check if user is authenticated
    const isAuthenticated = useIsAuthenticated();

    const enableFormsBasedOnRoles = async () => {
        //default to no roles
        let tokenRoles = [];

        //populate tokenRoles
        if(isAuthenticated){
            tokenRoles = await getRoles();
        }

        //show forms based on available roles
        if(tokenRoles.indexOf('MFA.Read') > -1 || tokenRoles.indexOf('MFA.ReadWrite') > -1 || tokenRoles.indexOf('MFA.Read.All') > -1 || tokenRoles.indexOf('MFA.ReadWrite.All') > -1){
            setShowMfaForm(true);
        }
        if (tokenRoles.indexOf('MFA.BulkUpload') > -1) {
            setShowMfaBulkForm(true);
        }

        if(tokenRoles.indexOf('MFA.TAP.CREATE') > -1){
            setShowTapForm(true);
        }
        
        if(tokenRoles.indexOf('KibanaLogs.Read') > -1 || tokenRoles.indexOf('KibanaLogs.Read') > -1){
            setShowAdLockoutForm(true);
            setShowSignInActivityForm(true);
        }

        if(tokenRoles.indexOf('KibanaLogs.Read') > -1 || tokenRoles.indexOf('KibanaLogs.Read.LockOuts') > -1){
            setShowAdLockoutForm(true);
        }

        if(tokenRoles.indexOf('Summerrain.ReadWrite') > -1){
            setShowSummerrainUsersForm(true);
        }

        if(tokenRoles.indexOf('B2C.Read') > -1 || tokenRoles.indexOf('B2C.ReadWrite') > -1 || tokenRoles.indexOf('B2C.TOU.Reset') > -1){
            setShowTouForm(true);
        }

        if(tokenRoles.indexOf('B2C.SignInLogs.Read') > -1){
            setShowB2CSignInEventsForm(true);
        }

        if(tokenRoles.indexOf('SharePoint.Read') > -1 || tokenRoles.indexOf('SharePoint.ReadWrite') > -1){
            setShowSharepointForm(true);
        }
        if (tokenRoles.indexOf('Logs.Read') > -1) {
            setShowActivityLogForm(true);
        }
        if (tokenRoles.indexOf('AppRegistration.Create') > -1) {
            setShowAppRegistrationForm(true);
        }

    }

    enableFormsBasedOnRoles();

    return (
        <NavDropdown title={HamburgerMenuImage} id="basic-nav-dropdown" >
            {showTapForm && <NavDropdown.Item as={Link} to="/tap">Temporary Access Pass</NavDropdown.Item>}
            {showMfaForm && <NavDropdown.Item as={Link} to="/mfa">MFA Method Detail</NavDropdown.Item>}
            {showMfaBulkForm && <NavDropdown.Item as={Link} to="/mfaBulk">MFA Bulk Upload</NavDropdown.Item>}
            {showSignInActivityForm && <NavDropdown.Item as={Link} to="/signInActivity">Sign-In Activity</NavDropdown.Item>}
            {showSummerrainUsersForm && <NavDropdown.Item as={Link} to="/summerrainUsers">Summerrain Guest Users</NavDropdown.Item>}
            {showAdLockoutForm && <NavDropdown.Item as={Link} to="/adLockout">AD Lockouts</NavDropdown.Item>}
            {showTouForm && <NavDropdown.Item as={Link} to="/tou">B2C TOU</NavDropdown.Item>}
            {showB2CSignInEventsForm && <NavDropdown.Item as={Link} to="/b2cSignInEvents">B2C Sign-In Events</NavDropdown.Item>}
            {showSharePointForm && <NavDropdown.Item as={Link} to="/sharePointPermissions">SharePoint Permissions</NavDropdown.Item>}
            {showActivityLogForm && <NavDropdown.Item as={Link} to="/activityLog">Activity Log</NavDropdown.Item>}
            {showAppRegistrationForm && <NavDropdown.Item as={Link} to="/appRegistration">Create App Registration</NavDropdown.Item>}
        </NavDropdown>
    )
}
